<template>
    <div class="single-img">
        <img :src="globalObj.other_page_bg.image">
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'globalObj'
    ]),
}
</script>
<style lang="scss" scoped>
.single-img{
    width:100%;
    min-height:315px;
    position: relative;
    img{
        width:1920px;
        height:315px;
        position: absolute;
        left:50%;
        margin-left:-960px;
        top:0px;
        z-index: 1;
    }
}
</style>
